<div class="idea_inn_head clrfx">
  <a routerLink="/" class="back left">{{ 'Pages.Offer.AllOffersLink' | translate }}</a>
  <a *ngIf="(!offer.statusId || offer.statusId == 101) && allowUserEdit"
     (click)="editOffer()"
     class="edit right">{{ 'Pages.Offer.EditLink' | translate }}</a>
</div>

<div class="space_content big_radius static_shadow">
  <div class="idea_info_bar clrfx">
    <div class="left">
      <div class="inf">
        № <b>{{ offer.number }}</b>
      </div>
      <div class="inf">
        <b>{{ offer.typeName }}</b>
      </div>
    </div>
    <div class="right" *ngIf="offer.publishDate">
      <div class="inf">
        {{ 'Pages.Offer.FieldPublishDate' | translate }}:
        <b>{{ offer.publishDate | date: 'dd.MM.yyyy' }}</b>
      </div>
    </div>
  </div>

  <div class="idea_info_head">
    <div class="name">{{ offer.name }}</div>
    <app-offer-status [statusId]="offer.statusId"
                      [statusName]="offer.statusName"
                      [draftText]="draftText"
                      [blockedText]="blockedText"
                      [blocked]="offer.blocked"></app-offer-status>
    <a *ngIf="offer.statusId == 101 && allowTypeEdit && allowUserEdit"
       id="change_status"
       class="change_status"
       (click)="changeStatus()">{{ 'Pages.Offer.ChangeStatus' | translate }}</a>
    <div class="tags">
      <div class="ins portf">
        {{ 'Pages.Offer.FieldOrganization' | translate }}: <b>{{ offer.organization }}</b>
      </div>
      <div class="ins portf">
        {{ 'Pages.Offer.FieldDepartment' | translate }}: <b>{{ offer.department }}</b>
      </div>
      <div class="ins portf">
        {{ 'Pages.Offer.FieldDivision' | translate }}: <b>{{ offer.division }}</b>
      </div>
      <div class="ins portf">
        {{ 'Pages.Offer.FieldBlock' | translate }}: <b>{{ offer.userBlockLevel < 3 ? '' : offer.userBlock }}</b>
      </div>
      <div class="ins tag" *ngIf="offer.lossTypes && offer.lossTypes.length > 0 && offer.typeId !== settings?.nornickelProblem_OfferKindId">
        {{ 'Pages.Offer.FieldLossType' | translate }}:
        <b *ngFor="let lossType of offer.lossTypes; let isLast = last;">{{ lossType }}<span *ngIf="!isLast">,&nbsp;</span></b>
      </div>
    </div>
  </div>

  <div class="change_tabs">
    <div class="changer tabs_idea_change taber clrfx">
      <ul>
        <li [ngClass]="[activeTab == 1 ? 'active' : '']">
          <a (click)="activeTab = 1" data-tab="tab_info">
            {{ 'Pages.Offer.TabDescription' | translate }}
          </a>
        </li>
        <li [ngClass]="[activeTab == 2 ? 'active' : '']">
          <a (click)="activeTab = 2" data-tab="tab_info">
            {{ 'Pages.Offer.TabHistory' | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="list_tabs info_idea">
    <div id="tab_info" [ngClass]="[activeTab == 1 ? 'tabs active' : 'tabs']">

      <ng-container *ngIf="offer.typeId !== settings?.nornickelStepForward_OfferKindId">
        <div class="idea_info_line">
          <div class="ttl">{{ 'Pages.Offer.FieldProblem' | translate }}:</div>
          <div class="desc">{{ offer.problem }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="offer.typeId === settings?.nornickelStepForward_OfferKindId">
        <div class="idea_info_line">
          <div class="ttl">{{ 'Pages.Offer.OfferKind_StepForward.FieldProblem' | translate }}:</div>
          <div class="desc">{{ offer.problem }}</div>
        </div>

        <div class="idea_info_line">
          <div class="ttl">{{ 'Pages.Offer.OfferKind_StepForward.FieldData1' | translate }}:</div>
          <div class="desc">{{ offer.data1 | date:'dd.MM.yyyy' }}</div>
        </div>
      </ng-container>

      <div class="idea_info_line" *ngIf="offer.reason">
        <div class="ttl">{{ 'Pages.Offer.FieldReason' | translate }}:</div>
        <div class="desc">{{ offer.reason }}</div>
      </div>

      <div class="idea_info_line" *ngIf="offer.solution">
        <div class="ttl">{{ 'Pages.Offer.FieldSolution' | translate }}:</div>
        <div class="desc">{{ offer.solution }}</div>
      </div>

      <ng-container *ngIf="offer.typeId !== settings?.nornickelStepForward_OfferKindId">
        <div class="idea_info_line" *ngIf="offer.hasEconomicEffectName">
          <div class="ttl">{{ 'Pages.Offer.FieldHasEconomicEffectName' | translate }}:</div>
          <div class="desc">{{ offer.hasEconomicEffectName }}</div>
        </div>
      </ng-container>

      <div class="idea_info_line" *ngIf="offer.result">
        <div class="ttl">
          {{
          offer.typeId === settings?.nornickelProblem_OfferKindId
          ? ('Pages.Offer.FieldComment' | translate)
          : ('Pages.Offer.FieldResult' | translate)
          }}
        </div>
        <div class="desc">{{ offer.result }}</div>
      </div>
      <div class="idea_info_line" *ngIf="offer.outlay">
        <div class="ttl">{{ 'Pages.Offer.FieldOutlay' | translate }}:</div>
        <div class="desc">{{ offer.outlay }}</div>
      </div>
      <div class="idea_info_line" *ngIf="offer.comment">
        <div class="ttl">{{ 'Pages.Offer.FieldComment' | translate }}:</div>
        <div class="desc">{{ offer.comment }}</div>
      </div>

      <ng-container *ngIf="offer.typeId !== settings?.nornickelStepForward_OfferKindId">
        <div class="idea_info_line" *ngIf="!offer.hiddenPublished">
          <div class="ttl">{{ 'Pages.Offer.FieldPublisher' | translate }}</div>
          <div class="desc">
            <ul class="list-position-inside">
              <li class="p-5-0">
                {{ offer.publisherName}}
              </li>
            </ul>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!offer.hiddenPublished">
        <div class="idea_info_line" *ngIf="isThereAnAuthor(offer.members, 'isAuthor')">
          <div class="ttl">{{ offer.typeId == settings?.nornickelOffer_OfferKindId ? ('Pages.Offer.FieldAuthor' | translate) : ('Pages.Offer.FieldAuthorProblem' | translate) }}:</div>
          <div class="desc">
            <ul class="list-position-inside">
              <ng-container *ngFor="let item of offer.members">
                <li *ngIf="item.isAuthor" class="p-5-0">
                  {{ item.fullName}}
                  <span *ngIf="offer.typeId == settings?.nornickelOffer_OfferKindId"
                        class="member-offer">
                    {{ item.partInProject }}&nbsp;%
                  </span>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>

        <div class="idea_info_line" *ngIf="isThereAnAuthor(offer.members, 'isCoAuthor')">
          <div class="ttl">{{ offer.typeId == settings?.nornickelOffer_OfferKindId ? ('Pages.Offer.FieldCoAuthor' | translate) : ('Pages.Offer.FieldCoAuthorProblem' | translate)}}:</div>

          <div class="desc">
            <ul class="list-position-inside">
              <ng-container *ngFor="let item of offer.members">
                <li *ngIf="item.isCoAuthor" class="p-5-0">
                  {{ item.fullName }}
                  &nbsp;
                  <span *ngIf="offer.typeId == settings?.nornickelOffer_OfferKindId"
                        class="member-offer">
                    {{ item.partInProject }}&nbsp;%
                  </span>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>

      <div class="idea_info_line"
           *ngIf="
          offer.agreeWithSuggestionsPolicy !== null &&
          offer.agreeWithSuggestionsPolicy !== undefined
        ">
        <div class="ttl">{{ 'Pages.Offer.FieldAgreeWithSuggestionsPolicy' | translate }}:</div>
        <div class="size_status" *ngIf="offer.agreeWithSuggestionsPolicy">
          {{ 'Pages.Offer.AnswerYes' | translate }}
        </div>
        <div class="size_status" *ngIf="!offer.agreeWithSuggestionsPolicy">
          {{ 'Pages.Offer.AnswerNo' | translate }}
        </div>
      </div>

      <div class="idea_info_line">
        <div class="ttl">{{ 'Pages.Offer.FieldHiddenPublished' | translate }}:</div>
        <div class="size_status" *ngIf="offer.hiddenPublished">
          {{ 'Pages.Offer.HiddenPublished' | translate }}
        </div>
        <div class="size_status" *ngIf="!offer.hiddenPublished">
          {{ 'Pages.Offer.NotHiddenPublished' | translate }}
        </div>
      </div>
      <div class="idea_info_line"
           *ngIf="offer.photosBeforeIntroduction && offer.photosBeforeIntroduction.length > 0">
        <div class="ttl">{{ 'Pages.Offer.FieldPhotosBefore' | translate }}:</div>
        <div class="list_photo clrfx">
          <img *ngFor="let photo of offer.photosBeforeIntroduction"
               class="img"
               [src]="offerDocumentAsDataUrl(photo)"
               (click)="downloadOfferDocument(photo)" />
        </div>
      </div>
      <div class="idea_info_line" *ngIf="offer.photosAfterIntroduction && offer.photosAfterIntroduction.length > 0">
        <div class="ttl">{{ 'Pages.Offer.FieldPhotosAfter' | translate }}:</div>
        <div class="list_photo clrfx">
          <span *ngFor="let photo of offer.photosAfterIntroduction"
                class="file"
                (click)="downloadOfferDocument(photo)">
            {{ photo.fileName }}
          </span>
        </div>
      </div>
      <div class="idea_info_line" *ngIf="offer.rubrics">
        <div class="ttl">{{ 'Pages.Offer.FieldRubric' | translate }}:</div>
        <div class="rubrika_list clrfx">
          <div class="rubrika">{{ offer.rubrics }}</div>
        </div>
      </div>
      <div class="idea_info_line" *ngIf="offer.offerClassificator && offer.typeId == settings?.nornickelProblem_OfferKindId">
        <div class="ttl">{{ 'Pages.Offer.FieldRubric' | translate }}:</div>
        <div class="classificator_list clrfx">
          <div class="classificator">{{ offer.offerClassificator }}</div>
        </div>
      </div>
    </div>
    <div id="tab_history" [ngClass]="[activeTab == 2 ? 'tabs active' : 'tabs']">
      <div class="list_idea">
        <div class="item big_radius static_shadow"
             *ngFor="let offerHistory of offer.offerHistories">
          <div class="bar clrfx">
            <div class="inf">
              <b>{{ offerHistory.statusName }}</b>
            </div>
            <div class="inf">{{ offerHistory.isAnonymousUser ? ('Pages.Offer.AnonymousUser' | translate) : offerHistory.userName }}</div>
            <div class="inf">{{ offerHistory.comment }}</div>
          </div>

          <div class="bar clrfx" style="margin-top: 0">
            <div class="inf">
              <b> {{ 'Pages.Offer.OfferHistoryDate' | translate }}:</b>
            </div>
            <div class="inf">{{offerHistory.date | date: 'dd.MM.yyyy'}}</div>
          </div>

          <div class="ttl">{{ 'Pages.Offer.OfferHistoryAttachment' | translate }}:</div>
          <div class="idea_info_line"
               *ngIf="offerHistory.attachments && offerHistory.attachments.length > 0">
            <div *ngFor="let attachment of offerHistory.attachments">
              <a (click)="downloadOfferDocument(attachment)">
                {{ attachment.fileName }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
